
import React, { useState, useRef } from 'react'
import { AsyncTypeahead } from 'react-bootstrap-typeahead'
import { locationByName } from '../services/locations'

export const LocationSelector = ({ exclude, onChange }) => {

    const [ locations, setLocations ] = useState([])
    const [ loading, setLoading ] = useState(false)

    const typeaheadEl = useRef(null)

    return (
        <AsyncTypeahead
            filterBy={() => true}
            id="select-location"
            isLoading={loading}
            labelKey={item => {
                return [item.name, item.location ? item.location.name : null, item.location && item.location.location ? item.location.location.name : null].filter(item => !!item).join(', ')
            }}
            onSearch={query => {
                setLoading(true)
                locationByName(query, exclude).then(res => {
                    setLocations(res)
                    setLoading(false)
                }).catch(e => {
                    console.log(e)
                    setLoading(false)
                })
            }}
            inputProps={{
                className: 'form-control',
                placeholder: 'Type city name, or zip code',
                autoComplete: 'new-password'
            }}
            onChange={selected => {
                const selectedLocation = selected[0]
                if(typeof onChange == 'function' && selectedLocation && selectedLocation.id){
                    onChange(selectedLocation)
                }
                typeaheadEl.current.clear()
                return null
            }}
            options={locations}
            ref={typeaheadEl}
        />
    )
}
